const left = require("../assets/images/catalogs/left.jpg").default;
const right = require("../assets/images/catalogs/right.jpg").default;
const bottom = require("../assets/images/catalogs/bottom.jpg").default;
const top_left = require("../assets/images/catalogs/top_left.jpg").default;
const top_right = require("../assets/images/catalogs/top_right.jpg").default;

export const itemData = [
  {
    img: left,
    title: "Áo thun",
    subtile: "Chỉ từ đ50,000",
    path: "/Ao/Ao-thun",
    rows: 2,
    cols: 2,
  },
  {
    img: top_left,
    title: "Hoodie",
    path: "/Ao/Ao-trum-dau",
    subtile: "Trên dưới đ150,000",
  },
  {
    img: top_right,
    title: "Sweater",
    path: "/Ao/Ao-tay-dai",
    subtile: "Trên dưới đ150,000",
  },  {
    img: right,
    title: "Quần dài",
    subtile: "Chỉ từ đ150,000",
    path: "/Quan/Quan-dai",
    rows: 2,
    cols: 2,
  },
  {
    img: bottom,
    title: "Nón",
    path: "/Phu-kien/Non",
    subtile: "Dưới đ180,000",
    cols: 2,
  },

];
